import React, { useState } from 'react';
import Messages from 'i18n/messages/mapping';
import { FormOutlined } from '@ant-design/icons';
import RibbonButton from 'common/components/button/RibbonButton';
import MappingConfig from 'pages/mapping/components/mapping-config/MappingConfig';

// *Mapping Property Config

const EditMappingConfig = ({
  mappingId,
  mappingConfig,
  mappingConfigStatus,
  selectedItemList,
}) => {
  const handleCreateMapping = () => {
    setVisible(true);
  };

  const isDisabled = selectedItemList.length !== 1 || !mappingConfig?.isOwner;

  const [visible, setVisible] = useState(false);

  const onCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <RibbonButton
        icon={<FormOutlined />}
        label={Messages.editMapping}
        onClick={handleCreateMapping}
        disabled={isDisabled}
      />
      {visible && (
        <MappingConfig
          mappingConfigStatus={mappingConfigStatus}
          mappingConfig={mappingConfig}
          visible={visible}
          setVisible={setVisible}
          onCancel={onCancel}
          mappingId={mappingId}
          isEdit
        />
      )}
    </>
  );
};

export default EditMappingConfig;
